import { render, staticRenderFns } from "./Rating.htm?vue&type=template&id=316417cc&scoped=true&"
import script from "./Rating.ts?vue&type=script&lang=js&"
export * from "./Rating.ts?vue&type=script&lang=js&"
import style0 from "./Rating.scss?vue&type=style&index=0&id=316417cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316417cc",
  null
  
)

export default component.exports